// Chips-sugerencia tappables — prompts de arranque para el copiloto.
//
// Se usan en DOS lugares: en el estado vacío (primera apertura) y en la fila
// sobre el input. Al tocar uno, el contenedor rellena el textarea y envía.

export const SUGERENCIAS = [
  '¿Cómo va la producción hoy?',
  'Paros de la semana y sus causas',
  'Mejor y peor línea del mes',
] as const;

interface ChipsSugerenciaProps {
  onSelect: (texto: string) => void;
  disabled?: boolean;
}

export function ChipsSugerencia({ onSelect, disabled }: ChipsSugerenciaProps) {
  return (
    <div className="flex flex-wrap gap-1.5">
      {SUGERENCIAS.map((s) => (
        <button
          key={s}
          type="button"
          disabled={disabled}
          onClick={() => onSelect(s)}
          className="rounded-full border border-border px-3 py-1 text-xs text-fg-secondary transition-colors hover:border-border-strong hover:bg-surface-overlay hover:text-fg disabled:cursor-not-allowed disabled:opacity-50"
        >
          {s}
        </button>
      ))}
    </div>
  );
}
